import React, { FC, useContext } from 'react'
import Button from '../../components/UI/button/GgButton'
import Modal from '../../components/modal/Modal'
import { useModal } from '../../customHooks/useModal'
import NewsForm from './NewsForm'
import { INews } from '../../models/INews'
import { $public } from '../../http'
import { Context } from '../..'
import parse from 'html-react-parser'
import { showLoadingToast, showSuccessToast } from '../../components/toasts'

interface INewsItem {
  item: INews,
  page?: number
  actionData?: any
}

const NewsItem: FC<INewsItem> = ({ item, page, actionData }) => {
  const { news } = useContext(Context);
  const { showModal, openModal, setModalShow, closeModal } = useModal();

  async function handleDelete() {
    if (window.confirm("Are you sure you want to delete this News !")) {
      showLoadingToast("Deleting news...");
      await news.deleteOne(item, page).then(()  =>{
        showSuccessToast("News deleted Successfully");
      })
      await news.loadList(page)
    }
  }

  function handleRecover(){
    if (window.confirm("Are you sure you want to Recover this News ?")) {
      showLoadingToast("Recover news...")
      news.deleteOne(item, page).then(() => {
        showSuccessToast("News Recover Successfully");
      })
    }
  }

  return (
    <div className="news-item">
      <div className="image">
        <img src={$public(item.mainImage || "")} alt="article" />
      </div>
      <div className="content">
        <div className="title">{item.name}</div>
        <div className="desc">{parse(`${item.content}`)}</div>
        {item.status === "deleted" ? 
        (
        <div className="controls">
          <Button label="Recover" onPress={handleRecover} />
        </div>
        ) : (
        <div className="controls">
          {actionData?.edit ? (
            <Button label="Edit" stylesType="border" onPress={openModal} />
          ): "" }
          {actionData?.delete ? (
            <Button label="Delete" onPress={handleDelete} />
          ): "" }
        </div>
        )}
      </div>
      <Modal title="Edit the news" show={showModal} onClose={setModalShow}>
        <NewsForm page={page} data={item} onClose={closeModal} />
      </Modal>
    </div>
  );
};

export default NewsItem